import React, { useCallback, useMemo, useState } from 'react'
import { ENDPOINTS } from 'apps/placeme/src/constants/endpoints'
import { useSelector } from 'react-redux'
import { RootState } from 'apps/placeme/src/redux/store'
import { TileSectionIds } from '@dataplace.ai/constants'
import styled from 'styled-components'
import isEmpty from 'lodash/isEmpty'
import { AlabAttractivenessFormFields, AlabAttractivenessFormState, FormFieldValue, IAlabAttractivenessTileData } from './@types/IAlabAttractivenessTileData'
import { AlabAttractivenessTile } from './AlabAttractivenessTile'
import { useAlabAttractivenessFormData } from './hooks/useAttractivenessFormData'

const ContentWrapper = styled.div`
  padding: 1.25rem;
`

const initialState: AlabAttractivenessFormState = {
  market: null,
}

const requiredFields = [
  AlabAttractivenessFormFields.market,
]

export const AlabAttractivenessModel: React.FC<{
  data: IAlabAttractivenessTileData,
  tileId: string,
}> = ({
  data,
  tileId,
}) => {
  const [formState, setFormState] = useState<AlabAttractivenessFormState>(initialState)
  const {
    analyseId,
    value: {
      lat, lng,
    } = {},
  } = useSelector((state: RootState) => state.location)

  const areAllFieldsFilled = useMemo(() => requiredFields.every(key => !isEmpty(formState[key])), [formState])

  const formDataObject = useAlabAttractivenessFormData(formState)

  const setFormValue = useCallback(
    (key: string, value: FormFieldValue) => {
      setFormState(prev => ({
        ...prev,
        [key]: value,
      }))
    },
    [],
  )

  const body = useMemo(() => ({
    coordinates: {
      lat: lat!,
      lng: lng!,
    },
    reportId: analyseId!,
    market: formState.market,
  }), [lat, lng, analyseId, formState])

  return (
    <ContentWrapper>
      <AlabAttractivenessTile
        areAllFieldsFilled={areAllFieldsFilled}
        body={body}
        categoryId={TileSectionIds.ALAB}
        data={data}
        endpoint={ENDPOINTS.ALAB_ATTRACTIVENESS_TILE}
        formDataObject={formDataObject}
        setFormValue={setFormValue}
        tileId={tileId}
      />
    </ContentWrapper>
  )
}
